export const phoneRegex = /^$|^(\+[0-9]{1,2})?[ ]?(\(?0?\)?[1-8])([-. ]?[0-9]{2}){4}$/;
export const postalCodeRegex = /^$|^[0-9]{4,5}$/;
